/*
 * @Author: your name
 * @Date: 2022-03-05 20:03:47
 * @LastEditTime: 2023-09-18 15:18:22
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyFileThumbList\index.jsx
 */
import React, { Component } from 'react';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import { doGraffiti } from '../../utils/doGraffiti';

export default class BsyFileThumbList extends Component {
    static defaultProps = {
        files: [],
    }
    constructor(props) {
        super(props);
        this.state = {
            files: props.files,
            dataId: props.dataId,
            formId: props.formId,
            appId: props.appId,
            widget: props.widget,
            online_edit: props.online_edit,
            online_edit_record: props.online_edit_record,
            is_file_down: props.is_file_down,
            check_image_exif: props.check_image_exif,
            formMode: props.formMode,
            rowData: props.rowData,
            authGroupId: props.authGroupId,
            isRili: props.isRili,
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

        this.setState({
            ...nextProps
        })
    }

    previewFile = (data, index) => {
        // console.log(data)
        const { files, dataId, formId, appId, widget, online_edit, online_edit_record, is_file_down, formMode, rowData, authGroupId, isRili, check_image_exif } = this.state;
        const _this = this;
        new window.FX.FilePreview({
            fieldName: widget.name || widget.widgetName,
            title: files.length === 1 ? files[index].name : widget.title || widget.text,
            files: files,
            currentItem: index,
            widgetType: "upload",
            appId: appId,
            dataId: dataId,
            formId: formId,
            online_edit: online_edit,
            online_edit_record: online_edit_record,
            is_file_down: is_file_down,
            check_image_exif: check_image_exif,
            autoClose: !1,
            formMode: formMode,
            saveValue: (i) => {
                this.setState({ files: i });
                BsyUtils.applyFunc(_this, _this.props.onStopEdit, [i], !1)
                let data = {
                    appId: appId,
                    authGroupId: authGroupId,
                    checkRepeat: [],
                    dataId: dataId,
                    designDataId: null,
                    entryId: formId,
                    formId: formId,
                    hasResult: true,
                    popupFormPath: this.popupFormPath,
                    values: {}
                };
                if (widget.subform) {
                    let id = widget.subformDataId
                    data["values"][widget.name || widget.widgetName] = {
                        file: i[0],
                        subform: widget.subform,  //如果是子表单 传子表单的id
                        id: id  //子表单数据id
                    }
                } else {
                    data["values"][widget.name || widget.widgetName] = {
                        file: i[0]
                    }
                }

                React.axios("/data/online_edit_update", data).then(res => {
                    console.log(res)
                })
            },
        })
    }

    render() {
        const { files, widget } = this.state
        let file = files;

        if (!file) {
            file = [];
        }

        if (file.length > 3) {
            file = file.slice(0, 3)
        }
        return (
            <div className="bsy-file-thumb-list" >

                <div className="thumb-list"  >
                    {
                        !file ? '' : file.map((data, index) => {


                            if (data.error) {
                                return '';
                            }

                            var o = data.name ? data.name.split(".").pop() : "";

                            return <div key={index} className="thumb-item" onClick={e => { e.stopPropagation(); this.previewFile(data, index) }}
                                onMouseEnter={(event) => {
                                    if (data.name) {
                                        window.FX.UI.showPopover({
                                            position: "bottomLeft",
                                            anchor: window.$(event.target),
                                            content: window.$('<span />').text(data.name),
                                            type: "dark"
                                        })
                                    }

                                }}
                                onMouseLeave={(event) => {
                                    if (data.name) {
                                        window.FX.UI.closePopover()
                                    }
                                }}
                            >
                                {
                                    BsyUtils.createFileThumb(o, "tiny", data.name)
                                }
                                <span className="thumb-name">{data.name}</span>
                            </div>
                        })
                    }
                    {
                        file.length > 3 && <div className="thumb-item" ><i className="icon-bsy-icongengduo1"></i></div>
                    }
                </div>
            </div>
        );
    }
}
